import {WebFormModel} from "capitalist-shared/src/core/model";
import {VerificationTypes} from '@/models/verification/verification';
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

export interface PayoutDocumentInterface extends Record<string, any> {
  verificationType: VerificationTypes;
  id: number;
}

export type {PayoutDocumentInterface as PayoutDocumentType};

export enum VerificableDocumentTypes {
  PAYOUT = 'payout',
  MASSPAYMENT = 'mass',
  SECURITY_CERTIFICATE = 'security/certificate',
  SECURITY_PIN = 'security/pin',
  SECURITY_TABLECODE = 'security/tablecode',
  SECURITY_2FA = 'security/googlecode',
  SECURITY_OTP = 'security/otp',
}

export class VerificationModel extends WebFormModel {
  protected document: any;

  loaded = false;

  loadingStatus = new RemoteRequestState();

  url = '/webapi/finance/payout/';
  documentType: VerificableDocumentTypes = VerificableDocumentTypes.PAYOUT;

  values: Record<string, any> = {
    verificationType: VerificationTypes.NONE,
    password: '',
    verificationData: '',
    dataForSign: '',
    dataForSignDecoded: '',
  };

  profile: any = null;

  setUrl(value: string) {
    this.url = value;
    return this;
  }

  getUrl() {
    const urls = {
      [VerificableDocumentTypes.PAYOUT]: '/webapi/verification/payout',
      [VerificableDocumentTypes.MASSPAYMENT]: '/webapi/verification/mass',
      [VerificableDocumentTypes.SECURITY_CERTIFICATE]: '/webapi/verification/signature',
      [VerificableDocumentTypes.SECURITY_PIN]: '/webapi/verification/pin',
      [VerificableDocumentTypes.SECURITY_TABLECODE]: '/webapi/verification/tablecode',
      [VerificableDocumentTypes.SECURITY_2FA]: '/webapi/verification/googlecode',
      [VerificableDocumentTypes.SECURITY_OTP]: '/webapi/verification/otp',
    }

    return urls[this.documentType];
  }

  submit(): any {
    this.loadingStatus.loadStart();
    this.errors.clear();

    const values = {...this.values, password: ''};

    return httpAxiosApi.post(this.getUrl(), {
      call: 'verify',
      // system: this.systemName,
      document: this.document.id,
      system: this.document.system,
      documentType: this.documentType,
      verificationType: this.values.verificationType,
      m: values,
    }).then((result: any) => {
      this.loadingStatus.loadEnd();
      return result.data;
    }).catch((err) => {
      this.checkAxiosError(err);
      this.loadingStatus.loadError();
      throw err;
    });
  }

  setDocument(document: any): any {
    this.document = document;
    if (document) this.values.verificationType = document.verificationType;
    return this;
  }

  setDocumentType(documentType: VerificableDocumentTypes): any {
    this.documentType = documentType;
    return this;
  }

  load(verificationType: any): any {
    return httpAxiosApi.post(this.getUrl(), {
      call: 'loadVerificationModel',
      verificationType,
      document: this.document ? this.document.id : null,
      documentType: this.documentType,
    }).then((result: any) => {
      this._setData(result.data);
      this.loaded = true;
      this.profile = {...result.data.profile};
      return result.data;
    }).catch((err) => {
      this.loaded = false;
      throw err;
    });
  }
}
